import i18next from 'i18next';
import { ITranslationSubSchema } from '../../../graphql/type/subSchema/translation';

export default function useLanguage() {
  function getText(arr?: ITranslationSubSchema[], code?: string) {
    if (arr) {
      const cu = i18next.languages[0];
      const las = arr.map((item) => item.la);

      if (arr.length > 0) {
        let obj;
        if (code && las.includes(code)) {
          obj = arr.find((item) => item.la === code);
        } else if (las.includes(cu)) {
          obj = arr.find((item) => item.la === cu);
        } else {
          obj = arr.find((item) => item.la === 'en');
        }

        return obj ? obj.text : arr[0].text;
      }
      return '';
    }
    return '';
  }

  return {
    getText,
  };
}
